export const UPDATE_OFFERS = "UPDATE_OFFERS";

export const updateOffers = (value) => ({
  type: UPDATE_OFFERS,
  value,
});
